import PageContainer from "../PageContainer";
import { ValueForm } from "./ValueForm";
import { useState } from "react";
import { usePreload } from "../../../contexts/DataContext/PreloadContext";
import { saveValue } from "../../../services/valueService";
import { valuesPageCache } from "../../../pages/cache/PageCache";

const emptyRow = {};

const AddValue = () => {
  const { showNotification } = usePreload();
  const [saving, setSaving] = useState(false);
  const onSave = async (updatedRow) => {
    if (!updatedRow.valueCode.trim()) {
      showNotification("Value code is required", "error");
      return false;
    }

    try {
      setSaving(true);
      const response = await saveValue(updatedRow);
      if (response instanceof Response && !response.ok)
        throw new Error("Save failed");
      valuesPageCache.clear();
      showNotification(`new value was added!`, "success");
      return true;
    } catch (e) {
      showNotification(
        `something went wrong when adding ${updatedRow?.valueCode} value.`,
        "error",
      );
      return false;
    } finally {
      setSaving(false);
    }
  };

  return (
    <PageContainer
      title="Create Value"
      subtitle="Add an ETIM value and its localized details"
      breadcrumbs={[
        { title: "ETIM Value", path: "/valuesnew" },
        { title: "New" },
      ]}
    >
      <ValueForm
        onSave={onSave}
        props={{
          row: emptyRow,
          uploading: saving,
          saveText: "Create",
          isUpdate: false,
        }}
      />
    </PageContainer>
  );
};

export default AddValue;
